type LinesProps = Readonly<{
  // SEMI-SKILLED TO TRACKS
  semiSkilledToTradesTechnical: boolean;
  semiSkilledToMiddleTier: boolean;
  semiSkilledToUpperTier: boolean;
  semiSkilledToTopTier: boolean;

  // ENTREPRENEURSHIP TO TRACKS
  entrepreneurshipToTradesTechnical: boolean;
  entrepreneurshipToMiddleTier: boolean;
  entrepreneurshipToUpperTier: boolean;
  entrepreneurshipToTopTier: boolean;
}>;

export const Lines = ({
  semiSkilledToTradesTechnical,
  semiSkilledToMiddleTier,
  semiSkilledToUpperTier,
  semiSkilledToTopTier,
  entrepreneurshipToTradesTechnical,
  entrepreneurshipToMiddleTier,
  entrepreneurshipToUpperTier,
  entrepreneurshipToTopTier,
}: LinesProps) => {
  return (
    <>
      {/* START TO SEMI-SKILLED */}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.1215 285.199C18.9499 286.371 17.0504 286.371 15.8789 285.199L2.80101 272.122C1.62944 270.95 1.62944 269.05 2.80101 267.879L15.8789 254.801C17.0504 253.629 18.9499 253.629 20.1215 254.801L31.442 266.122C32.0046 266.684 32.7677 267 33.5633 267H131C132.657 267 134 268.343 134 270C134 271.657 132.657 273 131 273H33.5633C32.7677 273 32.0046 273.316 31.442 273.879L20.1215 285.199Z"
        fill="#367FFF"
      />

      {/* DOTTED - ENTREPRENEURSHIP TO TRADES/TECHNICAL */}
      <line
        x1="524.5"
        y1="48.5"
        x2="524.5"
        y2="107.5"
        stroke={entrepreneurshipToTradesTechnical ? '#5090FF' : '#D5E4FF'}
        strokeWidth="5"
        strokeLinecap="round"
        strokeDasharray="4 12"
      />

      {/* DOTTED - ENTREPRENEURSHIP TO MIDDLE TIER */}
      <line
        x1="485.5"
        y1="176.5"
        x2="485.5"
        y2="235.5"
        stroke={entrepreneurshipToMiddleTier ? '#5090FF' : '#D5E4FF'}
        strokeWidth="5"
        strokeLinecap="round"
        strokeDasharray="4 12"
      />

      {/* DOTTED - ENTREPRENEURSHIP TO UPPER TIER */}
      <line
        x1="566.5"
        y1="183.5"
        x2="566.5"
        y2="343.5"
        stroke={entrepreneurshipToUpperTier ? '#5090FF' : '#D5E4FF'}
        strokeWidth="5"
        strokeLinecap="round"
        strokeDasharray="4 12"
      />

      {/* DOTTED - ENTREPRENEURSHIP TO TOP TIER */}
      <line
        x1="643.5"
        y1="187.5"
        x2="643.5"
        y2="498.5"
        stroke={entrepreneurshipToTopTier ? '#5090FF' : '#D5E4FF'}
        strokeWidth="5"
        strokeLinecap="round"
        strokeDasharray="4 12"
      />

      {/* SEMI-SKILLED TO TRADES/TECHNICAL */}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M157 46C157 44.3431 158.343 43 160 43L393 43C394.657 43 396 44.3431 396 46C396 47.6569 394.657 49 393 49L160 49C158.343 49 157 47.6569 157 46Z"
        fill={semiSkilledToTradesTechnical ? '#5090FF' : '#D5E4FF'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M160 44C161.657 44 163 45.3432 163 47L163 230C163 231.657 161.657 233 160 233C158.343 233 157 231.657 157 230L157 47C157 45.3431 158.343 44 160 44Z"
        fill={semiSkilledToTradesTechnical ? '#5090FF' : '#D5E4FF'}
      />

      {/* SEMI-SKILLED TO UPPER TIER */}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M306 386C306 384.343 307.343 383 309 383H474C475.657 383 477 384.343 477 386C477 387.657 475.657 389 474 389H309C307.343 389 306 387.657 306 386Z"
        fill={semiSkilledToUpperTier ? '#5090FF' : '#D5E4FF'}
      />

      {/* SEMI-SKILLED TO MIDDLE TIER */}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M306.476 271.683C306.488 270.026 307.841 268.693 309.498 268.705L396.044 269.338C397.701 269.35 399.034 270.703 399.022 272.359C399.01 274.016 397.657 275.35 396 275.337L309.454 274.705C307.797 274.693 306.464 273.34 306.476 271.683Z"
        fill={semiSkilledToMiddleTier ? '#5090FF' : '#D5E4FF'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M306 385L306 273C306 271.343 307.343 270 309 270C310.657 270 312 271.343 312 273L312 385"
        fill={semiSkilledToMiddleTier ? '#5090FF' : '#D5E4FF'}
      />

      {/* SEMI-SKILLED TO TOP TIER */}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M309 500C307.343 500 306 498.657 306 497L306 388C306 386.343 307.343 385 309 385C310.657 385 312 386.343 312 388L312 497C312 498.657 310.657 500 309 500Z"
        fill={semiSkilledToTopTier ? '#5090FF' : '#D5E4FF'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M306 497C306 495.343 307.343 494 309 494H524C525.657 494 527 495.343 527 497C527 498.657 525.657 500 524 500H309C307.343 500 306 498.657 306 497Z"
        fill={semiSkilledToTopTier ? '#5090FF' : '#D5E4FF'}
      />

      {/* SEMI-SKILLED TOWARDS MIDDLE/UPPER/TOP TIER */}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M160 312C161.657 312 163 313.343 163 315L163 386C163 387.657 161.657 389 160 389C158.343 389 157 387.657 157 386L157 315C157 313.343 158.343 312 160 312Z"
        fill={
          semiSkilledToMiddleTier || semiSkilledToUpperTier || semiSkilledToTopTier
            ? '#5090FF'
            : '#D5E4FF'
        }
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M157 386C157 384.343 158.343 383 160 383H309C310.657 383 312 384.343 312 386C312 387.657 310.657 389 309 389H160C158.343 389 157 387.657 157 386Z"
        fill={
          semiSkilledToMiddleTier || semiSkilledToUpperTier || semiSkilledToTopTier
            ? '#5090FF'
            : '#D5E4FF'
        }
      />
    </>
  );
};
